import { render, staticRenderFns } from "./quillEditorCom2.vue?vue&type=template&id=5382de9c&lang=pug&"
import script from "./quillEditorCom2.vue?vue&type=script&lang=js&"
export * from "./quillEditorCom2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports